<template>
  <div class="common-audioBox">
    <div class="aduio-btn mr15">
      <img
        @click="autoPlay(`audio${audioIndex}`, audioIndex)"
        :src="palyImg"
        class="audioImg"
        alt
      />
      <audio
        :id="`audio${audioIndex}`"
        ref="audioOne"
        class="myaudio"
        :preload="true"
        :src="audioInformation.outcall_playurl"
        @timeupdate="timeUpdate"
      >
        Your browser does not support the audio element.
      </audio>
    </div>
    <div class="audio-process">
      <el-slider
        class="commonSlider"
        :show-tooltip="false"
        :max="audioInformation.allPlayTime"
        v-model="audioInformation.currentPlayTime"
      ></el-slider>
    </div>
    <div class="audio-time ml10">
      {{ Math.floor(parseInt(audioInformation.currentPlayTime || 0) / 60) }}:{{
        parseInt(audioInformation.currentPlayTime || 0) % 60
      }}
      /
      {{ Math.floor(parseInt(audioInformation.allPlayTime || 0) / 60) }}:{{
        parseInt(audioInformation.allPlayTime || 0) % 60
      }}
    </div>
    <!--
    <audio
        :id="`audio${audioIndex}`"
        ref="audioOne"
        class="myaudio"
        controls
        :src="audioInformation.outcall_playurl"
      >Your browser does not support the audio element.</audio>
    -->
  </div>
</template>
<script>
export default {
  name: "common-audioBox",
  props: ["audioOneInfo", "audioIndex"],
  data() {
    return {
      currentDom: null,
      currentIndex: 0,
      palyImg: require("@/assets/images/icon/play.png"),
      pauseImg: require("@/assets/images/icon/pause.png"),
    };
  },
  components: {},
  updated() {},
  created() {
    // (() => {})(this.audioOneInfo, "睡下觉执行");
  },
  methods: {
    // 播放
    autoPlay(dom) {
      (() => {})(dom);
      // this.$emit('autoPlay',this.audioIndex);
      let _this = this;
      let audioDom = document.getElementById(dom.toString());
      this.currentDom = audioDom;
      this.audioInformation.isPlay = !this.audioInformation.isPlay;
      let audio = document.getElementsByClassName("myaudio");
      let audioImg = document.getElementsByClassName("audioImg");
      Array.prototype.forEach.call(audio, function (element, index) {
        element.pause();
        audioImg[index].src = _this.palyImg;
      });
      (() => {})(this.audioInformation);
      // duration***时长，currentTime****播放进度
      if (this.audioInformation.isPlay) {
        audioImg[_this.audioIndex].src = _this.pauseImg;
        audioDom.play();
      } else {
        audioDom.pause();
      }

      audioDom.addEventListener("ended", () => {
        this.audioInformation.currentPlayTime = 0;
        document.getElementsByClassName("audioImg")[this.audioIndex].src =
          this.palyImg;
        this.audioInformation.isPlay = !this.audioInformation.isPlay;
      });
    },
    timeUpdate() {
      if (this.currentDom) {
        let audioImg = document.getElementsByClassName("audioImg");
        (() => {})(this.currentDom.currentTime, this.audioInformation);
        this.audioInformation.currentPlayTime = this.currentDom.currentTime;
        if (
          this.audioInformation.currentPlayTime ==
          this.audioInformation.allPlayTime
        ) {
          audioImg[this.audioIndex].src = this.palyImg;
        }
      }
    },
  },
  mounted() {},
  watch: {},
  computed: {
    audioInformation() {
      return this.audioOneInfo;
    },
  },
};
</script>
<style lang="less">
.common-audioBox {
  display: flex;
  align-items: center;
  .aduio-btn {
    img,
    audio {
      width: 24px;
      height: 24px;
    }
  }
  .audio-time {
    font-size: 12px;
    color: rgba(24, 24, 24, 1);
    line-height: 16px;
    letter-spacing: 1px;
  }
  .audio-process {
    width: 300px;
    .el-slider__button {
      background: #20a8d8;
      width: 12px;
      height: 12px;
    }
  }
  > .myaudio {
    width: 450px;
  }
}
</style>